<template>
    <div class="max-w-7xl mx-auto flex flex-col md:flex-row flex-wrap lg:flex-no-wrap mb-6 pt-6 px-4 sm:px-6 lg:px-8"
        :class="{ 'border-t border-gray-200': topBorder }"
    >
      <div class="pr-4 sm:pr-6 lg:pr-8 md:w-1/3">
        <div class="rounded-lg mb-5 mt-2">
          <div class="text-18px font-semibold mb-1">{{ title }}</div>
          <div class="text-sm text-gray-600 whitespace-no-wrap">{{ subtitle }}</div>
        </div>
      </div>
      <div class="bg-white py-4 px-6 md:m-2 rounded-lg shadow-lg w-full md:w-2/3">
        <slot></slot>
      </div>
    </div>
  </template>
  
<script>
export default {
    name: 'InfoPanel',
    props: {
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            required: true
        },
        topBorder: {
            type: Boolean,
            default: true
        },
    },
}
</script>